// js
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import CreateDSAWorkflow from '../../components/account/CreateDSAWorkflow';
import { confirmBeginConvertDSAWorkflow, cancelCreateDSAWorkflow, promptForNewDSALinkedOpportunities, confirmSalesforceSyncError, confirmBeginConvertCustomerDSAWorkflow } from '../../actions/createDSAWorkflowActions';
import { createDSA, cloneDSA, convertCustomerDSA } from '../../actions/dsaActions';
import { linkOpportunity, unlinkOpportunity } from '../../actions/opportunityActions';
import { getAvailableOpportunities, getHasAvailableOpportunities, getSummary } from '../../selectors/dsa/opportunitiesSelectors';
import moment from 'moment';


const mapStateToProps = (state) => {

  return {
    step: state.createDSAWorkflow.step,
    opportunities: state.opportunities,
    summary: getSummary(state, {dsa: state.createDSAWorkflow.dsa}),
    availableOpportunities: getAvailableOpportunities(state),
    hasAvailableOpportunities: getHasAvailableOpportunities(state),
    isCreatingDSA: state.dsa.loadingNew,
    clone: state.createDSAWorkflow.clone,
    convert: state.createDSAWorkflow.convert,
    convertCustomer: state.createDSAWorkflow.convertCustomer,
    endWithPpt: state.createDSAWorkflow.endWithPpt,
    dsa: state.createDSAWorkflow.dsa,
    dsaType: state.createDSAWorkflow.dsaType,
    loading: state.createDSAWorkflow.loading,
    salesforceSyncError: state.createDSAWorkflow.salesforceSyncError
  };
};

const cloneString = 'clone', convertString = 'convert', createString = 'create';

const newDSAName = (action, oldName, type, oldType) => {
  let time = moment().format('DD MMM YYYY');
  let actionDesc = '';
  if (action === cloneString) {
    if (oldType && type !== oldType){
      actionDesc = ' - Cloned To Full ';
    } else {
      actionDesc = ' - Cloned ';
    }
  } else if (action === convertString) {
    actionDesc = ' - Converted ' ;
  } else {
    actionDesc = 'Created ';
  }
  let newName = oldName ? oldName + actionDesc + time : actionDesc + time;
  return newName;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { generatePPTXAndDownload } = ownProps;
  return {
    onCreateCustomerDSA: () => dispatch(promptForNewDSALinkedOpportunities()),
    onDismiss: () => dispatch(cancelCreateDSAWorkflow()),
    onConfirmBeginConvertDSAWorkflow: () => dispatch(confirmBeginConvertDSAWorkflow()),
    onDenyCustomer: () => {
      dispatch(cancelCreateDSAWorkflow());
      generatePPTXAndDownload();
    },
    onConfirmBeginConvertCustomerDSAWorkflow: (dsa, opportunities, availableOpportunities, hasAvailableOpportunities) => {
      dispatch(confirmBeginConvertCustomerDSAWorkflow(dsa, opportunities, availableOpportunities, hasAvailableOpportunities));
    },
    onCreateTestDSA: (dsa, dsaType, clone) => {
      const { account, user } = ownProps;
      return dispatch(
        clone ? (
          cloneDSA({
            name: newDSAName(cloneString, dsa.name, dsaType, dsa.dsaType),
            dsaType,
            dsaId: dsa.id,
            test: true
          })
        ) : (
          createDSA({
            name: newDSAName(createString),
            dsaType,
            userId: user.id,
            test: true
          })
        )
      )
      .then(response => (
        browserHistory.push(`/account/${account.sfid}/dsa/${response.data.dsa.id}/sources`)
      ));
    },

    onSubmitLinkedOpportunities: (dsa, dsaType, opportunities, clone, convertCustomer, endWithPpt) => {
      const { account, user, generatePPTXAndDownload } = ownProps;
      return dispatch(
        (convertCustomer ?
          (convertCustomerDSA({
            name: newDSAName(convertString, dsa.name, dsaType),
            dsaId: dsa.id,
            dsaType,
            opportunities: opportunities.map(o => o.sfid),
            test: false
          })) :
            (clone ? (
                cloneDSA({
                  name: newDSAName(cloneString, dsa.name, dsaType, dsa.dsaType),
                  dsaId: dsa.id,
                  dsaType,
                  opportunities: opportunities.map(o => o.sfid),
                  test: false
                })
              ) : (
                createDSA({
                  name: newDSAName(createString),
                  dsaType,
                  userId: user.id,
                  opportunities: opportunities.map(o => o.sfid),
                  test: false
                })
              )
          )
        )
      )
      .then(response => {
        if (endWithPpt) {
          generatePPTXAndDownload();
        } else {
          browserHistory.push(`/account/${account.sfid}/dsa/${response.data.dsa.id}/sources`);
        }
      });
    },
    onConfirmSalesforceSyncError: (dsa) => {
      const { account } = ownProps;
      dispatch(confirmSalesforceSyncError());
      browserHistory.push(`/account/${account.sfid}/dsa/${dsa.id}/sources`);
    },
    linkOpportunity: (opportunity, dsa) => {
      return dispatch(linkOpportunity(opportunity, dsa));
    },
    unlinkOpportunity: (opportunity, dsa) => {
      return dispatch(unlinkOpportunity(opportunity, dsa));
    }
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onConfirmBeginConvertCustomerDSAWorkflow: () => {
    dispatchProps.onConfirmBeginConvertCustomerDSAWorkflow(stateProps.dsa, stateProps.opportunities, stateProps.availableOpportunities, stateProps.hasAvailableOpportunities);
  },
  onDenyCustomer: () => {
    dispatchProps.onDenyCustomer(stateProps.dsa);
  },
  onCreateTestDSA: () => {
    dispatchProps.onCreateTestDSA(stateProps.dsa, stateProps.dsaType, stateProps.clone);
  },
  onSubmitLinkedOpportunities: (opportunities) => {
    dispatchProps.onSubmitLinkedOpportunities(stateProps.dsa, stateProps.dsaType, opportunities, stateProps.clone, stateProps.convertCustomer, stateProps.endWithPpt);
  },
  onConfirmSalesforceSyncError: () => {
    dispatchProps.onConfirmSalesforceSyncError(stateProps.dsa);
  }
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateDSAWorkflow);



// WEBPACK FOOTER //
// ./src/containers/account/CreateDSAWorkflow.js